import React, { useState } from 'react';

const N  = '#0A2540';
const E  = '#7C4DFF';
const ED = '#6030E8';

const pubs = [
  {
    title: 'Role of Digital Financial Services in Locally-led Adaptation Initiatives',
    source: 'MicroSave Network',
    year: '2024',
    url: 'https://www.microsave.net/2024/06/24/role-of-digital-financial-services-in-locally-led-adaptation-initiatives/',
    icon: '📝',
  },
  {
    title: 'How Digital Financial Solutions Are Fuelling Financial Inclusion & Economic Growth',
    source: 'CNBC Africa',
    year: '2024',
    url: 'https://www.cnbcafrica.com/media/6370676616112/how-digital-financial-solutions-are-fueling-financial-inclusion-economic-growth/',
    icon: '📺',
  },
  {
    title: 'Digital Financial Inclusion in Rwanda: Successes, Usage Gaps, and the Next Priorities',
    source: 'MicroSave Consulting (MSC)',
    year: '2026',
    url: 'https://www.microsave.net/2026/05/25/digital-financial-inclusion-in-rwanda-successes-usage-gaps-and-the-next-priorities/',
    icon: '📝',
  },
  {
    title: "Financing Africa's Fisheries: From Informality to Investability",
    source: 'MicroSave Consulting (MSC)',
    year: '2026',
    url: '#', // TODO: add the article URL
    icon: '📝',
  },
];

const panelTopics = [
  { icon: '💰', topic: 'Financial Literacy for Women & Youth',   desc: 'Building foundational money management skills to enable women and youth traders to save, borrow, and invest with confidence.' },
  { icon: '🐟', topic: 'Inclusive Market Access in Fisheries',   desc: 'Bridging the gap between fishing communities and formal financial systems through targeted product design and digital tools.' },
  { icon: '📲', topic: 'Digital Financial Services Adoption',    desc: 'Strategies for accelerating uptake of mobile money and digital lending among underserved cross-border fish traders.' },
  { icon: '🤝', topic: 'Cross-border Trade & Value Chains',      desc: 'Strengthening regional trade corridors to empower women and youth with access to markets, finance, and support networks.' },
];

function PortraitCard({ src, caption, onClick }) {
  return (
    <div onClick={onClick} style={{ position: 'relative', borderRadius: 14, overflow: 'hidden', aspectRatio: '3/4', cursor: 'zoom-in' }}>
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `url(${src})`, backgroundSize: 'cover', backgroundPosition: 'center',
        filter: 'blur(14px) brightness(0.45)', transform: 'scale(1.12)',
      }} />
      <img src={src} alt={caption} style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', display: 'block' }} />
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 2,
        background: 'linear-gradient(transparent, rgba(10,37,64,0.85))',
        padding: '28px 16px 14px', color: 'rgba(255,255,255,0.92)', fontSize: '0.82rem', fontWeight: 500, textAlign: 'center',
      }}>
        {caption}
      </div>
    </div>
  );
}

function GroupCard({ src, caption, onClick }) {
  return (
    <div onClick={onClick} style={{ position: 'relative', borderRadius: 14, overflow: 'hidden', aspectRatio: '4/3', cursor: 'zoom-in' }}>
      <img src={src} alt={caption} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0,
        background: 'linear-gradient(transparent, rgba(10,37,64,0.80))',
        padding: '28px 16px 14px', color: 'rgba(255,255,255,0.92)', fontSize: '0.82rem', fontWeight: 500, textAlign: 'center',
      }}>
        {caption}
      </div>
    </div>
  );
}

/* Reusable neutral section label on dark backgrounds */
function DarkLabel({ children }) {
  return (
    <div style={{
      display: 'inline-block',
      background: 'rgba(255,255,255,0.10)',
      color: 'rgba(255,255,255,0.80)',
      border: '1px solid rgba(255,255,255,0.18)',
      padding: '4px 14px', borderRadius: 20,
      fontSize: '0.78rem', fontWeight: 700, marginBottom: 12, letterSpacing: '1px',
    }}>
      {children}
    </div>
  );
}

export default function Publications() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section id="publications" className="section" style={{ background: N }}>
      <div className="container">

        {/* ── Publications ── */}
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <DarkLabel>THOUGHT LEADERSHIP</DarkLabel>
          <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '2.2rem', color: '#fff', fontWeight: 800 }}>Publications</h2>
          <div style={{ width: 60, height: 4, background: E, borderRadius: 2, margin: '14px auto 0' }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24, maxWidth: 900, margin: '0 auto' }}>
          {pubs.map((p, i) => (
            <a key={i} href={p.url} target="_blank" rel="noreferrer" style={{
              background: 'rgba(255,255,255,0.05)', borderRadius: 14,
              border: '1px solid rgba(255,255,255,0.10)', padding: 28,
              display: 'block', textDecoration: 'none', transition: 'all 0.3s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(124,77,255,0.45)'; e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.background = 'rgba(124,77,255,0.07)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.10)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
            >
              <div style={{ fontSize: '2rem', marginBottom: 14 }}>{p.icon}</div>
              <h3 style={{ color: '#fff', fontSize: '1rem', fontWeight: 600, lineHeight: 1.5, marginBottom: 12 }}>{p.title}</h3>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: E, fontSize: '0.82rem', fontWeight: 600 }}>
                  <i className="fas fa-external-link-alt" style={{ marginRight: 6 }} />{p.source}
                </span>
                <span style={{ color: 'rgba(255,255,255,0.28)', fontSize: '0.8rem' }}>{p.year}</span>
              </div>
            </a>
          ))}
        </div>

        {/* Blog CTA */}
        <div style={{ textAlign: 'center', marginTop: 48 }}>
          <p style={{ color: 'rgba(255,255,255,0.38)', marginBottom: 16, fontSize: '0.9rem' }}>Read more articles and insights on Dennis's blog</p>
          <a href="/blog" style={{
            background: E, color: '#fff', padding: '12px 28px', borderRadius: 8,
            fontWeight: 700, fontSize: '0.95rem', display: 'inline-flex', alignItems: 'center', gap: 8,
            boxShadow: '0 4px 18px rgba(124,77,255,0.30)', transition: 'all 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = ED; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = E;  e.currentTarget.style.transform = 'none'; }}
          >
            <i className="fas fa-book-open" /> Visit Blog
          </a>
        </div>

        {/* ══ PANEL MODERATIONS ══ */}
        <div style={{ marginTop: 96 }}>

          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <DarkLabel>PANEL MODERATIONS</DarkLabel>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '2.2rem', color: '#fff', fontWeight: 800 }}>
              Speaking & Moderation
            </h2>
            <div style={{ width: 60, height: 4, background: E, borderRadius: 2, margin: '14px auto 0' }} />
            <p style={{ color: 'rgba(255,255,255,0.50)', marginTop: 20, maxWidth: 620, margin: '20px auto 0', lineHeight: 1.8, fontSize: '0.97rem' }}>
              Facilitating high-level, solution-focused discussions that connect practitioners, policymakers,
              and community voices around financial literacy and economic empowerment in Africa.
            </p>
          </div>

          {/* Event card */}
          <div style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 16, padding: '32px 36px',
            maxWidth: 900, margin: '0 auto 56px',
            display: 'grid', gridTemplateColumns: '1fr auto', gap: 24, alignItems: 'center',
          }} className="event-card">
            <div>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                background: 'rgba(124,77,255,0.14)', color: E,
                border: '1px solid rgba(124,77,255,0.30)',
                padding: '4px 14px', borderRadius: 20,
                fontSize: '0.78rem', fontWeight: 700, letterSpacing: '0.5px', marginBottom: 14,
              }}>
                <i className="fas fa-microphone" /> PANEL MODERATOR
              </div>
              <h3 style={{ color: '#fff', fontFamily: "'Poppins', sans-serif", fontWeight: 800, fontSize: '1.2rem', lineHeight: 1.4, marginBottom: 12 }}>
                Women & Youth Economic Empowerment in Fisheries —{' '}
                <span style={{ color: E }}>Through Inclusive Market Access</span>
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.9rem', lineHeight: 1.8, marginBottom: 18, maxWidth: 560 }}>
                A MicroSave Consulting convening bringing together regulators, financial institutions,
                NGOs, and fishing community representatives to advance financial literacy and inclusive
                access for women and youth traders across East &amp; Central Africa.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                {[
                  { icon: 'fas fa-building',       text: 'MicroSave Consulting (MSC)' },
                  { icon: 'fas fa-map-marker-alt', text: 'Radisson Blu, Nairobi' },
                  { icon: 'fas fa-globe',          text: 'Kenya · Uganda · Tanzania · DRC · Zambia · Nigeria' },
                ].map((d, i) => (
                  <span key={i} style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.83rem', display: 'flex', alignItems: 'center', gap: 7 }}>
                    <i className={d.icon} style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.75rem' }} />{d.text}
                  </span>
                ))}
              </div>
            </div>
            {/* Donor tags */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, borderLeft: '1px solid rgba(255,255,255,0.08)', paddingLeft: 32 }} className="event-donors">
              {['Mastercard Foundation', 'TradeMark Africa', 'AfCFTA'].map((d, i) => (
                <div key={i} style={{
                  background: 'rgba(255,255,255,0.06)', borderRadius: 8,
                  padding: '7px 16px', fontSize: '0.78rem',
                  color: 'rgba(255,255,255,0.50)', fontWeight: 600,
                  border: '1px solid rgba(255,255,255,0.08)', whiteSpace: 'nowrap',
                }}>
                  {d}
                </div>
              ))}
            </div>
          </div>

          {/* Topics grid */}
          <div style={{ maxWidth: 900, margin: '0 auto 48px' }}>
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '2px' }}>KEY TOPICS MODERATED</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }} className="topics-grid">
              {panelTopics.map((t, i) => (
                <div key={i} style={{
                  background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: 12, padding: '20px 22px',
                  display: 'flex', gap: 16, alignItems: 'flex-start', transition: 'all 0.25s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.20)'; e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                >
                  <div style={{
                    width: 44, height: 44, borderRadius: 10, flexShrink: 0,
                    background: 'rgba(255,255,255,0.08)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem',
                  }}>
                    {t.icon}
                  </div>
                  <div>
                    <div style={{ color: '#fff', fontWeight: 700, fontSize: '0.9rem', marginBottom: 6 }}>{t.topic}</div>
                    <div style={{ color: 'rgba(255,255,255,0.48)', fontSize: '0.82rem', lineHeight: 1.7 }}>{t.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Gallery divider */}
          <div style={{ maxWidth: 900, margin: '0 auto 36px', display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.08)' }} />
            <span style={{ color: 'rgba(255,255,255,0.22)', fontSize: '0.72rem', letterSpacing: '2px', fontWeight: 700 }}>EVENT GALLERY</span>
            <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.08)' }} />
          </div>

          {/* 3-photo grid: 2 group + 1 portrait */}
          <div style={{ maxWidth: 900, margin: '0 auto' }}>
            {/* Group photos row */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, marginBottom: 16 }}>
              <GroupCard
                src="/images/panels/panel-session.jpg"
                caption="Moderating the panel discussion on financial inclusion in fisheries"
                onClick={() => setLightbox('/images/panels/panel-session.jpg')}
              />
              <GroupCard
                src="/images/panels/panel-group.jpg"
                caption="With panelists — representatives from across Kenya's fisheries value chain"
                onClick={() => setLightbox('/images/panels/panel-group.jpg')}
              />
            </div>
            {/* Single portrait — centered */}
            <div style={{ maxWidth: 340, margin: '0 auto' }}>
              <PortraitCard
                src="/images/panels/dennis-podium-1.jpg"
                caption="Addressing delegates on digital finance & financial literacy"
                onClick={() => setLightbox('/images/panels/dennis-podium-1.jpg')}
              />
            </div>
          </div>

          {/* Quote */}
          <div style={{ maxWidth: 700, margin: '48px auto 0', borderLeft: `4px solid ${E}`, paddingLeft: 24 }}>
            <p style={{ color: 'rgba(255,255,255,0.60)', fontSize: '1rem', lineHeight: 1.9, fontStyle: 'italic' }}>
              "Financial literacy is not just about understanding money — it's about giving women and youth
              in fishing communities the confidence and tools to participate equally in the economy,
              access credit, and build lasting livelihoods."
            </p>
            <div style={{ marginTop: 12, color: E, fontSize: '0.85rem', fontWeight: 700 }}>
              — Dennis Kuria, Panel Moderator
            </div>
          </div>

        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{
          position: 'fixed', inset: 0, zIndex: 1000,
          background: 'rgba(10,37,64,0.94)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'zoom-out', padding: 24,
        }}>
          <img src={lightbox} alt="Panel" style={{ maxWidth: '90vw', maxHeight: '88vh', borderRadius: 12, boxShadow: '0 24px 80px rgba(0,0,0,0.6)' }} />
          <button onClick={() => setLightbox(null)} style={{
            position: 'absolute', top: 20, right: 24,
            background: 'rgba(255,255,255,0.12)', border: 'none',
            color: '#fff', fontSize: '1.5rem', width: 44, height: 44,
            borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>×</button>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .event-card { grid-template-columns: 1fr !important; }
          .event-donors { border-left: none !important; padding-left: 0 !important; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 16px; flex-direction: row !important; flex-wrap: wrap; justify-content: flex-start; }
          .topics-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
